angular.module('bmsApp.merrymaids.job')
	.directive('mmJobCleanRotationView', [
		function () {
			return {
				restrict: 'E',
				scope: {
					rooms: '=ngModel',
					cleanType: '@',
					nextCleanRotationNo: '<'
				},
				templateUrl: 'ng/merrymaids/job/directives/mmJobCleanRotationView/MMJobCleanRotationView.html',
				link: function (scope, element, attrs, controllers) {
					
					scope.range = function (n) {
						return new Array(parseInt(n));
					};
					
					scope.max_rotation_no = 0;
					
					function setMaxRotationNo() {
						scope.max_rotation_no = 0;
						if (angular.isArray(scope.rooms)) {
							for (var i = 0; i < scope.rooms.length; i++) {
								var room = scope.rooms[i];
								var rotationKey;
								if (scope.cleanType === 'clean') {
									rotationKey = 'clean_rotations';
								}
								else if (scope.cleanType === 'deep_clean') {
									rotationKey = 'deep_clean_rotations';
								}
								for (var i2 = 0; i2 < room[rotationKey].length; i2++) {
									var rotation = room[rotationKey][i2];
									if (rotation.rotation_no > scope.max_rotation_no) {
										scope.max_rotation_no = rotation.rotation_no;
									}
								}
							}
						}
					}
					
					scope.$watch(function () {
						return scope.rooms;
					}, function (value) {
						setMaxRotationNo();
					}, true);
				}
			}
		}
	]);